import { render, staticRenderFns } from "./PrintPayment.vue?vue&type=template&id=ddf7f35e"
import script from "./PrintPayment.vue?vue&type=script&lang=js"
export * from "./PrintPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports